/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Bio_Intro_MidInputs */

const en_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` and `)
};

const ar_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` و `)
};

const bn_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` এবং `)
};

const de_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`und`)
};

const es_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`y`)
};

const fr_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`et`)
};

const pt_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e`)
};

const zh_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`和`)
};

const tr_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ve`)
};

const ru_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`и`)
};

const pl_about_bio_intro_mid = /** @type {(inputs: About_Bio_Intro_MidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i`)
};

/**
* | output |
* | --- |
* | "and" |
*
* @param {About_Bio_Intro_MidInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_bio_intro_mid = /** @type {((inputs?: About_Bio_Intro_MidInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Bio_Intro_MidInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_bio_intro_mid(inputs)
	if (locale === "bn") return bn_about_bio_intro_mid(inputs)
	if (locale === "de") return de_about_bio_intro_mid(inputs)
	if (locale === "es") return es_about_bio_intro_mid(inputs)
	if (locale === "fr") return fr_about_bio_intro_mid(inputs)
	if (locale === "pt") return pt_about_bio_intro_mid(inputs)
	if (locale === "zh") return zh_about_bio_intro_mid(inputs)
	if (locale === "tr") return tr_about_bio_intro_mid(inputs)
	if (locale === "ru") return ru_about_bio_intro_mid(inputs)
	if (locale === "pl") return pl_about_bio_intro_mid(inputs)
	return en_about_bio_intro_mid(inputs)
});